// @flow
import { InstanceOpinometroActionTypes } from './constants';

const INIT_STATE = {
    instanceOpinometro: {},
    listaInstanceOpinometro: [],
    loading: false,
    error: false,
    formSubmited: false
};

type InstanceOpinometroAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { instanceOpinometro?: {} | null, listaInstanceOpinometro?: [] | null, loading?: boolean, +value ?: boolean };

const InstanceOpinometro = (state: State = INIT_STATE, action: InstanceOpinometroAction): any => {
    // console.log(action);
    switch (action.type) {
        case InstanceOpinometroActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case InstanceOpinometroActionTypes.GET_INSTANCE_OPINOMETRO: {
                    return {
                        ...state,
                        instanceOpinometro: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case InstanceOpinometroActionTypes.LIST_INSTANCE_OPINOMETROS: {
                    return {
                        ...state,
                        listaInstanceOpinometro: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case InstanceOpinometroActionTypes.ADD_INSTANCE_OPINOMETRO: {
                    return {
                        ...state,
                        instanceOpinometro: action.payload.data,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case InstanceOpinometroActionTypes.UPDATE_INSTANCE_OPINOMETRO:
                case InstanceOpinometroActionTypes.DELETE_INSTANCE_OPINOMETRO: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case InstanceOpinometroActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case InstanceOpinometroActionTypes.GET_INSTANCE_OPINOMETRO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        instanceOpinometro: {},
                        loading: false,
                    };
                }
                case InstanceOpinometroActionTypes.LIST_INSTANCE_OPINOMETROS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaInstanceOpinometro: [],
                        loading: false,
                    };
                }
                case InstanceOpinometroActionTypes.ADD_INSTANCE_OPINOMETRO: {
                    return {
                        ...state,
                        instanceOpinometro: {},
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case InstanceOpinometroActionTypes.UPDATE_INSTANCE_OPINOMETRO:
                case InstanceOpinometroActionTypes.DELETE_INSTANCE_OPINOMETRO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case InstanceOpinometroActionTypes.GET_INSTANCE_OPINOMETRO:
            return { ...state, error: false, loading: true };
        case InstanceOpinometroActionTypes.LIST_INSTANCE_OPINOMETROS:
            return { ...state, error: false, loading: true };
        case InstanceOpinometroActionTypes.ADD_INSTANCE_OPINOMETRO:
            return { ...state, error: false, loading: true };
        case InstanceOpinometroActionTypes.UPDATE_INSTANCE_OPINOMETRO:
            return { ...state, error: false, loading: true };
        case InstanceOpinometroActionTypes.DELETE_INSTANCE_OPINOMETRO:
            return { ...state, error: false, loading: true };
        case InstanceOpinometroActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                instanceOpinometro: {},
                listaInstanceOpinometro: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default InstanceOpinometro;
